import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import LoginPage from '@/pages/login';

const SearchSchema = z.object({
  reason: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  validateSearch: (search) => SearchSchema.parse(search),
  component: function LoginRoute() {
    const { reason } = Route.useSearch();
    return <LoginPage reason={reason} />;
  },
});
